import React, { useState, useEffect } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight, } from "react-icons/md";

import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { albumDefaultURL } from "../../../components/CommonApis/CommonAudioApis";
import { ActionFormatterComponent, videoFormatter } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import { adminApiHeader } from "../../../components/CommonApis/CommonApiUrl";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { toast } from "react-toastify";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { getItem } from "../../../Utils/localStorageUtils";

function Managealbum() {
  const { fetchRequest, deleteImageFile } = useMyContext()
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithoutRefresh] = useState(false)

  const baseURL = process.env.REACT_APP_Baseurl
  const userRole = getItem("role");

  const deleteApi = `${baseURL}/admin/album/multi-delete`;


  //Bootstrap Table util start
  const columns = [
    {
      dataField: "albumname",
      text: "Album",
      formatter: (cell, row) => videoFormatter(cell, row, albumDefaultURL?.viewTab),
      headerClasses: 'video-width-table'
    },
    {
      dataField: "uploaded_by",
      text: "Upload by",
    },

    userRole == 1 && {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => <ActionFormatterComponent cell={cell} row={row} link={albumDefaultURL?.editRouteLink} action={singleDelete} />,
    }
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: Number(filteredData?.length)
    }]
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    style: { width: '30px' },
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((r) => r.id);
        setItemToDelete(allIds);
      } else {
        setItemToDelete([]);
      }
    },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  //Bootstrap Table util end

  // api start
  const fetchData = async () => {
    try {
      const response = await axios.get(`${albumDefaultURL?.listApi}`, { headers: adminApiHeader });
      const result = response?.data?.[albumDefaultURL?.fetchArrayName];
      const updatedList = result?.map((item) => {
        const UploadStatus = item?.uploaded_by === "1" ? "Admin" : item?.uploaded_by === "4" ? "Channel Partner" : item?.uploaded_by === "5" ? "Content Partner" : "";
        return { ...item, uploaded_by: UploadStatus };
      });
      setApiData(updatedList);
      setFilteredData(updatedList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleDeleteImage = async () => {
    await deleteImageFile(itemToDelete, "AudioAlbum");
  }

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    
    await handleDeleteImage();
    try {
      await fetchRequest({
        method: 'DELETE',
        url: `${deleteApi}`,
        params: {},
        data: { id: itemToDelete },
      }).then((response) => {
        if (response?.status) {
          setWithoutRefresh(!withOutRefresh);
          toast.success(response?.message);
          setShowOverlay(false);
          setItemToDelete([])
        }
      })
        .catch((error) => {
          toast.error(error?.response?.data?.message || error?.message);
          setShowOverlay(false);
        })
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  // api end
  const closeModal = () => {
    setModelClose(!closeModal);
    setItemToDelete([]);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const handleFilterChange = (data) => {
    setFilteredData(data);
  };

  useEffect(async () => {
    fetchData();
  }, [withOutRefresh]);

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
      <AdminNavbar heading={albumDefaultURL?.headingText} totalDataLength={apiData?.length} deleteCount={itemToDelete?.length} navigation={albumDefaultURL?.addRouteLink} deleteMethod={openModal} navText={albumDefaultURL?.buttonText} />
      <div className="theme-bg-color p-3 rounded-2 bootstrapTable  multi-delete-width" >
        <AdminHeader searchMethod={handleFilterChange} reduceData={filteredData} originalData={apiData} fileName={albumDefaultURL?.exportFileName} customAlbum />
        <BootstrapTable keyField="id" pagination={paginationFactory(options)} columns={columns} data={filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" selectRow={selectRow} selectAll={selectAll} />
      </div>
    </>
  );
}

export default Managealbum;